// ChecklistModal.js
import React from "react";
import ButtonWithIcon from "../../components/ButtonwithIcon/ButtonWithIcon";
import "./ChecklistModal.scss";

const ChecklistModal = ({
  isOpen,
  remarks,
  onRemarksChange,
  onClose,
  onComplete,
}) => {
  if (!isOpen) return null;

  return (
    <div className="checklist-modal-overlay">
      <div className="checklist-modal-content">
        {/* Header */}
        <div className="checklist-modal-header">
          <h3>Complete Checklist Item</h3>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        {/* Body */}
        <div className="checklist-modal-body">
          <label htmlFor="checklist-remarks" className="remarks-label">
            Remarks <span className="optional">(Optional)</span>
          </label>
          <textarea
            id="checklist-remarks"
            value={remarks}
            onChange={(e) => onRemarksChange(e.target.value)}
            placeholder="Add any remarks about completing this item..."
            rows="3"
            className="remarks-textarea"
          />
        </div>

        {/* Footer */}
        <div className="checklist-modal-footer">
          <ButtonWithIcon
            icon="mdi:close-circle"
            text="Cancel"
            onClick={onClose}
            className="cancel-button form-action"
          />
          <ButtonWithIcon
            icon="mdi:check-circle"
            text="Complete Task"
            onClick={onComplete}
            className="submit-button form-action"
          />
        </div>
      </div>
    </div>
  );
};

export default ChecklistModal;
